<template>
  <div>
    <!-- Video -->
    <video-view
      video-id="https://vimeo.com/625577468/47d3ed3bf5"
      variant="is-green"
    >
      <!-- Title (first) -->
      <template slot="title-first">
        <div>
          {{ $t('header_10') }}
        </div>
      </template>

      <!-- Title (second) -->
      <template slot="title-second">
        <div class="underline">
          {{ $t('header_11') }}
        </div>
      </template>

      <!-- Video -->
      <video
        autoplay
        muted
        loop
        playsinline
      >

        <source
          type="video/mp4"
          src="https://media.blissapplications.com/videos/desktop-1440-clip-careers.mp4"
        >

      </video>
    </video-view>

    <!-- Title -->
    <title-view variant="primary">
      {{ $t('careers_1') }}
    </title-view>

    <!-- Subtitle -->
    <div class="has-max-width">
      <title-view variant="subtitle">
        <span>
          {{ $t('careers_2') }}
        </span>
      </title-view>
    </div>

    <!-- Subtitle -->
    <div class="has-max-width">
      <title-view variant="subtitle">
        <span>
          {{ $t('careers_3_1') }}
        </span>
      </title-view>
    </div>

    <!-- Subtitle -->
    <div class="has-max-width">
      <title-view variant="subtitle">
        <span>
          {{ $t('careers_3_2') }}
        </span>
      </title-view>
    </div>

    <!-- Work -->
    <video-thumbnail-inline-view video-id="706152061">
      <template slot="image">
        <picture>
          <source
            media="--small"
            data-srcset="/static/images/careers2-mobile.png,
            /static/images/careers2-mobile@2x.png 2x"
          >

          <source
            media="--large"
            data-srcset="/static/images/careers2.png"
          >

          <img
            class="lazyload"
            data-sizes="auto"
            data-src="/static/images/careers2.png"
          >
        </picture>
      </template>
    </video-thumbnail-inline-view>

    <!-- Subtitle -->
    <div class="has-max-width">
      <title-view variant="subtitle">
        <span>
          {{ $t('careers_4') }}
        </span>
      </title-view>
    </div>

    <CareersView />
    <footer-follow-view />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
  name: 'CareersIndex',
  components: {
    TitleView: () => import('@/components/title/title-view'),
    CareersView: () => import('@/components/careers/zoho-careers-view'),
    VideoView: () => import('@/components/video/video-view'),
    VideoThumbnailInlineView: () => import('@/components/video/video-thumbnail-inline-view'),
    FooterFollowView: () => import('@/components/footer/footer-follow-view')
  },

  data() {
    return {
      isLoaded: false
    };
  },

  metaInfo: {
    title: 'Careers: Join an award-winning team!',
    meta: [
      {
        name: 'description',
        content: 'We’re always on the lookout for world-class product managers, software engineers, designers and marketeers to join us.'
      },
      {
        property: 'og:url',
        content: 'https://www.blissapplications.com/careers'
      },
      {
        property: 'og:title',
        content: 'Careers: Join an award-winning team!'
      },
      {
        property: 'og:description',
        content: 'We’re always on the lookout for world-class product managers, software engineers, designers and marketeers to join us.'
      },
      {
        property: 'og:image',
        content: 'https://www.blissapplications.com/static/images/bliss-share-facebook-careers.png'
      },
      {
        name: 'twitter:title',
        content: 'Careers: Join an award-winning team!'
      },
      {
        name: 'twitter:description',
        content: 'We’re always on the lookout for world-class product managers, software engineers, designers and marketeers to join us.'
      },
      {
        name: 'twitter:image',
        content: 'https://www.blissapplications.com/static/images/bliss-share-facebook-careers.png'
      }
    ]
  },

  computed: {
    ...mapState('careers', {
      careers: (state) => state.careers
    }),
    notHiring() {
      if (!this.isLoaded) { return null; }
      if (!this.careers.length) {
        return this.$t('careers_7');
      }
      return this.$t('careers_5');
    }
  },

  methods: {
    ...mapActions('careers', [
      'getCareers'
    ])
  }
};
</script>



// WEBPACK FOOTER //
// index.vue